/**
 * Question Bank Service
 * API calls for question bank management
 */

import axios from 'axios';

const API_URL = '/api/question-bank';

/**
 * Trigger question extraction for a book
 */
export const triggerExtraction = async (bookId) => {
  const response = await axios.post(`${API_URL}/extract/${bookId}`, {}, {
    withCredentials: true
  });
  return response.data;
};

/**
 * Get extraction status for a book
 */
export const getExtractionStatus = async (bookId) => {
  const response = await axios.get(`${API_URL}/status/${bookId}`, {
    withCredentials: true
  });
  return response.data;
};

/**
 * Get book statistics
 */
export const getBookStats = async (bookId) => {
  const response = await axios.get(`${API_URL}/stats/${bookId}`, {
    withCredentials: true
  });
  return response.data;
};

/**
 * Get queue statistics
 */
export const getQueueStatistics = async () => {
  const response = await axios.get(`${API_URL}/queue/stats`, {
    withCredentials: true
  });
  return response.data;
};

/**
 * Get job details
 */
export const getJob = async (jobId) => {
  const response = await axios.get(`${API_URL}/job/${jobId}`, {
    withCredentials: true
  });
  return response.data;
};

/**
 * Cancel a job
 */
export const cancelJob = async (jobId) => {
  const response = await axios.delete(`${API_URL}/job/${jobId}`, {
    withCredentials: true
  });
  return response.data;
};

/**
 * Retry a failed job
 */
export const retryJob = async (jobId) => {
  const response = await axios.post(`${API_URL}/job/${jobId}/retry`, {}, {
    withCredentials: true
  });
  return response.data;
};

/**
 * Get questions with filters
 */
export const getQuestions = async (filters = {}) => {
  const response = await axios.get(`${API_URL}/questions`, {
    params: filters,
    withCredentials: true
  });
  return response.data;
};

/**
 * Get review queue
 */
export const getReviewQueue = async (page = 1, limit = 50) => {
  const response = await axios.get(`${API_URL}/review-queue`, {
    params: { page, limit },
    withCredentials: true
  });
  return response.data;
};

/**
 * Update a question
 */
export const updateQuestion = async (questionId, updates) => {
  const response = await axios.put(`${API_URL}/questions/${questionId}`, updates, {
    withCredentials: true
  });
  return response.data;
};
